module.exports = __webpack_public_path__ + "img/logo.89f5ce18.png";